angular.module('elogbooksServices').service('serviceProviderAdvancedFiltersModal', ['$uibModal', 'advancedFilterService', function ($uibModal, advancedFilterService) {

    return {
        open: function (collections, resources, config) {
            return $uibModal.open({
                templateUrl: '/modules/common/modals/advancedFilters/modal-advanced-filters-modal.html',
                size: 'xl',
                controller: 'advancedServiceProviderFiltersModalController',
                controllerAs: 'vm',
                resolve: {
                    config: function () {
                        var defaultConfig = {
                            view: 'serviceproviders',
                            titleMessage: 'ARE_YOU_SURE_HEADER',
                            bodyMessage: 'ARE_YOU_SURE'
                        };

                        return angular.extend({}, defaultConfig, config);
                    },
                    serviceProviderGroups: advancedFilterService.getFilterData('serviceProviderGroups',resources),
                    sitesCollectionResponse: advancedFilterService.getFilterData('sites',resources),
                    siteGroupsCollectionResponse: advancedFilterService.getFilterData('siteGroups',resources)
                }
            });
        }
    };
}]);
